/**
 * Doctor module catalog — keys used in package.enabled_modules.
 * These drive sidebar visibility and route gating.
 *
 * Rules:
 *   - If user has NO package (has_package=false) OR enabled_modules is empty,
 *     frontend treats it as "all modules enabled" (backwards-compat with free_starter).
 *   - If enabled_modules is non-empty, strict filtering is applied.
 */

// Keys MUST stay stable once set — they are persisted in DB on each package document.
export const DOCTOR_MODULES = [
  { key: '4k_ultrasound', label: '4K Ultrason Üretim' },
  { key: '4d_simulation', label: '4D Simülasyon' },
  { key: 'studio', label: 'Stüdyo' },
  { key: 'live_editor', label: 'Canlı Editör' },
  { key: 'biometrik', label: 'Biyometrik Ölçüm' },
  { key: 'parametric_editor', label: 'Parametrik Editör' },
  { key: 'ai_face', label: 'AI Yüz Üretimi' },
  { key: 'womens_health', label: 'Kadın Sağlığı' },
];

// Route path → module key map. Used by ModuleGuard.
export const ROUTE_TO_MODULE = {
  '/doctor/ultrasound-4k': '4k_ultrasound',
  '/doctor/studio': 'studio',
  '/doctor/editor': 'live_editor',
  '/doctor/biometrik': 'biometrik',
  '/doctor/parametric': 'parametric_editor',
  '/doctor/ai-face': 'ai_face',
  '/doctor/womens-health': 'womens_health',
};

// Sidebar item key → module key map. Used by Sidebar filter.
export const SIDEBAR_TO_MODULE = {
  '/doctor/womens-health': 'womens_health',
};

/**
 * Returns true if the module is enabled for the user.
 * Backwards-compatible: if enabled_modules is empty or has_package=false, returns true.
 */
export const isModuleEnabled = (modulesState, moduleKey) => {
  if (!moduleKey) return true;
  if (!modulesState) return true; // not yet loaded — assume enabled, guard re-runs on change
  const { enabled_modules, has_package } = modulesState;
  if (!has_package) return true;
  if (!Array.isArray(enabled_modules) || enabled_modules.length === 0) return true;
  return enabled_modules.includes(moduleKey);
};
